import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY, Button, COLORS, RADIUSES } from '@sortlist-frontend/design-system/legacy';

export const List = styled.ul<{ asideMenu: string; itemCount: number }>`
  display: grid;
  grid-template-rows: repeat(14, auto);
  grid-template-rows: ${({ itemCount }) => (itemCount > 14 ? `repeat(${itemCount}, auto)` : 'repeat(14, auto)')};
  grid-auto-flow: column;
  column-gap: 4rem;
  justify-content: left;
  grid-template-columns: 1fr 1fr;

  list-style-type: ${({ asideMenu }) => (asideMenu !== 'false' ? 'none' : 'inherit')};
  padding-left: ${({ asideMenu }) => (asideMenu !== 'false' ? '1.5rem' : '1.25rem')};

  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
    grid-auto-flow: row;
    grid-template-columns: auto;
  }
`;

export const Menu = styled.div<{ asideMenu: string }>`
  opacity: 1;
  z-index: 1;
  background-color: ${({ asideMenu }) => (asideMenu !== 'false' ? COLORS.SECONDARY_100 : 'transparent')};
`;

export const Card = styled.div`
  top: 2rem;
`;

export const MainLink = styled.a`
  color: ${COLORS.SECONDARY_700};
  &:hover {
    color: ${COLORS.PRIMARY_500};
  }
`;

export const Header = styled.header`
  padding-bottom: 14rem;
`;

export const Title = styled.h1`
  font-size: 4rem;

  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
    font-size: 3rem;
  }
`;

export type IndexProps = {
  selected?: boolean;
  subLevel?: true;
};

export const IndexItem = styled.div`
  ${(props: IndexProps) => `
  color: ${props.selected ? COLORS.PRIMARY_500 : COLORS.SECONDARY_900};
  background-color: ${props.selected ? COLORS.PRIMARY_100 : 'transparent'};

  &:hover {
    color: ${COLORS.PRIMARY_500};
    background-color: ${props.subLevel ? COLORS.PRIMARY_200 : COLORS.PRIMARY_100};

    svg {
      color: ${COLORS.PRIMARY_500};
    }
  }
`}
`;

export const StickyBlock = styled.div`
  top: 2rem;
`;

export const Gradient = styled.div`
  pointer-events: none;

  &:after {
    content: '';
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: ${RADIUSES.md};
    background: linear-gradient(
      180deg,
      rgba(250, 250, 250, 0) 0%,
      rgba(250, 250, 250, 0) 75%,
      rgba(250, 250, 250, 1) 100%
    );
  }
`;

export const ScrollingArea = styled.div`
  max-height: 20rem;
  pointer-events: auto;
`;
